import { Component, Input } from '@angular/core';
import { BgContrastDirective } from '@df/ui/atomic/atom/color/bg-contrast.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { IFashionRecommendationsColourData } from '../fashion-recommendations.interface';
@Component({
    selector: 'fashion-recommendations-colour',
    templateUrl: './fashion-recommendations-colour.component.html',
    standalone: true,
    imports: [HrefComponent, BgContrastDirective],
    styleUrls: ['./fashion-recommendations-colour.component.scss']
})
export class FashionRecommendationsColourComponent {
    @Input({
        required: true
    })
    colourData!: IFashionRecommendationsColourData;
}
